const goodsAdd = () => import('@/views/main/goods/add/add.vue')
export default {
  path: '/main/goods/add',
  name: 'goodsAdd',
  component: goodsAdd,
  children: []
}
